<template>

    <div class="flex gap-4 pt-2.5">
        <Card class="flex-1" style="overflow: hidden; text-align: center">
            <template #title>
                <b>{{ totalContratos }}</b>
            </template>
            <template #content>
                <p class="m-0 text-orange-500"><b>Meus Contratos</b></p>
            </template>
        </Card>
    </div>

    <div>
        <div class="flex gap-2 my-2">
            <!-- Gráfico de Linha -->
            <Card class="w-6">
                <template #title>
                    <h4 class="m-0">MINHAS ETAPAS</h4>
                </template>
                <template #content>
                    <Chart v-if="etapasUsuario?.labels?.length && etapasUsuario?.datasets?.length" type="line" :data="etapasUsuario" :options="estiloGeral" />
                </template>    
            </Card>

            <!-- Gráfico Colunas Horizontal -->
            <Card class="w-6">
                <template #title>
                    <h4 class="m-0">MEUS STATUS DE ETAPAS</h4>
                </template>
                <template #content>
                    <Chart v-if="statusEtapasUsuario?.labels?.length && statusEtapasUsuario?.datasets?.length" type="bar" :data="statusEtapasUsuario" :options="estiloColunaVertical" />
                </template>
            </Card>
        </div>

        <Card>
            <template #title>
                <h4 class="m-0">Pendências</h4>
            </template>
            <template #content>
                <DataTable :value="lista" :loading="isLoadingLista" size="small" stripedRows showGridlines scrollable scrollHeight="calc(100vh - 300px)">
                    <Column style="width: 100px" field="id" header="#" sortable></Column>
                    <Column field="descricao" header="Descricao" sortable></Column>
                    <Column field="id_primario" header="ID Primário" sortable></Column>
                    <Column field="id_secundario" header="ID Secundário" sortable></Column>
                    <Column field="etapa" header="Etapa" sortable></Column>
                    <Column field="created_at" header="Data/Hora" sortable>
                        <template #body="{ data }">
                            {{ dateFormat(data.created_at) }}
                            <span v-if="!data.resolvido" class="font-italic">
                                ({{ data.dias }} dias)
                            </span>
                        </template>
                    </Column>
                    <Column style="width: 150px" bodyClass="flex justify-content-end gap-1">
                        <template #body="{ data }">
                            <i v-if="data.resolvido" class="pi pi-check-square text-green-400 flex align-items-center" v-tooltip.top="'Resolvido'"></i>
                            <i v-else class="pi pi-check-square text-red-400 flex align-items-center" v-tooltip.top="'Pendente'"></i>

                            <Button icon="pi pi-file-check" title="Contrato" severity="help" size="small"
                                @click="openFormContrato(data)" />
                            <Button icon="pi pi-pen-to-square" title="Atualizar" severity="info" size="small"
                                @click="openFormPendencia(data)" />
                            <Button icon="pi pi-trash" title="Remover" severity="danger" size="small"
                                @click="remove(data)" />
                        </template>
                    </Column>

                    <template #empty>
                        <div class="text-center text-gray-600">
                            Nenhum registro encontrado
                        </div>
                    </template>
                </DataTable>
            </template>
        </Card>

        <PendenciaForm :visible="visibleFormPendencia" :data="item" @close="closeForm" @save="loadPendencias" />
        <ContratoForm :visible="visibleFormContrato" :id="item.contrato_id" :permissoes="permissoes" @close="closeForm" @save="loadPendencias" />
    </div>
</template>

<script>
import Message from 'primevue/message';
import Button from "primevue/button";
import SafeChart from '@/components/SafeChart.vue';
import Card from 'primevue/card';

import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

import Contrato from '@/service/contrato.js';
import Pendencia from '@/service/pendencia.js';

import PendenciaForm from '@/page/pendencia/Form.vue';
import ContratoForm from '@/page/contrato/Form.vue';

import Moment from 'moment';

export default {
    components: {
        Message,
        Button,
        Chart: SafeChart,
        Card,
        DataTable,
        Column,

        /* Form */
        PendenciaForm,
        ContratoForm,
    },
    data() {
        return {
            lista: [],
            isLoadingLista: false,
            item: {},
            visibleFormPendencia: false,
            visibleFormContrato: false,

            totalContratos: 0,
            etapasUsuario: {},
            statusEtapasUsuario: {},

            estiloColunaVertical: {
                responsive: true,
                plugins: {
                    legend: {
                        display: true,
                        position: 'top'
                    }
                }
            },

            estiloGeral: {
                responsive: true,
                plugins: {
                    legend: {
                        display: true,
                        position: 'top'
                    }
                }
            },

            permissoes: permissoes,
        }
    },
    beforeMount() {
        document.addEventListener("onPermissios", event => this.permissoes = event.permissoes);
    },
    mounted() {
        this.loadMeusContratos();
        this.loadMinhasEtapasSemanal();
        this.loadMinhasEtapasQuantidades();
        this.loadPendencias();
    },
    methods: {
        openFormPendencia(item) {
            this.item = { ...item };
            this.visibleFormPendencia = true;
        },
        openFormContrato(item) {
            this.item = { ...item };
            this.visibleFormContrato = true;
        },
        closeForm(event) {
            this.item = {};
            this.visibleFormPendencia = false;
            this.visibleFormContrato = false;
        },
        dateFormat(value) {
            if (!value) return;
            return Moment(value).format("DD/MM/YYYY HH:mm");
        },
        loadPendencias() {
            this.isLoadingLista = true;
            Pendencia.list(['order[id]=asc', 'filter[resolvido]=0', 'limit=10'].join("&"))
                .then(response => {
                    this.lista = response.data.data;
                })
                .finally(() => this.isLoadingLista = false);
        },
        loadMinhasEtapasSemanal() {
            let date = new Date();
            Contrato.minhasEtapasSemanal([`data=${date.toISOString().split('T')[0]}`].join("&"))
                .then(response => {
                    const data      = response.data.data;
                    const labels    = response.data.labels;
                    const datasets  = [];
                    data.forEach((item, idx) => {
                        item.etapas.forEach((item2, idx2) => {
                            if(!datasets[idx2]) {
                                datasets[idx2] = {
                                    label: item2.etapa,
                                    data: [],
                                    tension: 0.4,
                                }
                            }
                            datasets[idx2].data.push(item2.total);
                        });
                    });

                    this.etapasUsuario = {
                            labels: labels,
                            datasets: datasets,
                        }
                });

            // etapasUsuario: {
            //     labels: ['6 dias atrás', '5 dias atrás', '4 dias atrás', '3 dias atrás', '2 dias atrás', 'Ontem', 'Atual'],
            //     datasets: [
            //         { label: 'Lead', data: [7, 3, 9, 5, 6, 8, 4] },
            //         { label: 'Cotação', data: [8, 4, 6, 5, 9, 3, 7] },
            //         { label: 'Provedor', data: [5, 7, 3, 6, 8, 4, 9] },
            //         { label: 'Assinatura', data: [2, 5, 8, 7, 3, 6, 4] },
            //         { label: 'Agendamento', data: [9, 3, 6, 4, 5, 7, 2] },
            //         { label: 'Instalação', data: [4, 8, 5, 3, 7, 9, 6] },
            //         { label: 'Concluído', data: [6, 2, 4, 9, 3, 8, 5] },
            //         { label: 'Cancelado', data: [3, 6, 7, 5, 4, 9, 2] }
            //     ],
            // },
        },
        loadMinhasEtapasQuantidades() {
            let date = new Date();
            Contrato.minhasEtapasQuantidade()
                .then(response => {
                    const data      = response.data.data;
                    const labels    = [];
                    const datasets  = [
                        { label: 'Status', data: [] },
                        { label: 'Pendências', data: [] }
                    ];
                    
                    data.forEach((item, idx) => {
                        if(!labels[idx]) {
                            labels[idx] = item.etapa;
                        }
                        datasets[0].data.push(item.total);
                        datasets[1].data.push(item.pendencias);
                    });

                    this.statusEtapasUsuario = {
                            labels: labels,
                            datasets: datasets,
                        }
                    // statusEtapasUsuario: {
                    //     labels: ['Lead', 'Cotação', 'Provedor', 'Assinatura', 'Agendamento', 'Instalação', 'Concluído', 'Cancelado'],
                    //     datasets: [
                    //         { label: 'OK', data: [6, 2, 2, 5, 3, 5, 3, 5] },
                    //         { label: 'Pendência', data: [4, 1, 1, 4, 2, 3, 2, 4] }
                    //     ],
                    // },
                });
        },
        loadMeusContratos() {
            Contrato.totalMeusContratos()
                    .then(response => {
                        this.totalContratos = response.data.total
                    });
        },
    }
}
</script>
